import React from 'react';
import { Container, Typography, Box, Button, Stack, Avatar } from '@mui/material';
import { BuildOutlined, BookOutlined, AccountCircleOutlined, ArticleOutlined, EmailOutlined } from '@mui/icons-material';
import Header from '../components/blog/components/Header';
import Footer from '../components/blog/components/Footer';
import AppTheme from '../components/shared-theme/AppTheme';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { env, fetchGithub, fetchProjects } from '../services/AppService';
import Grid from '@mui/material/Grid2';
import { projectData, aboutHtml } from '../data';
import Link from '@mui/material/Link';
import './ProjectPage.css';

export default function AboutPage(props)
{
	return (
		<>
		<AppTheme {...props}>
		<CssBaseline enableColorScheme />
		<Header />
		<Container
			maxWidth='lg'
			component='main'
			sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
		>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 13}}>
      		<div>
      		  <Typography variant="h1" gutterBottom>
      		    About Me
      		  </Typography>
			  {/*<Typography>Some are notable, many are experiments. </Typography>*/}
      		</div>
			<Box
				alignItems='center'
				justifyContent='center'
				display='flex'
				sx={{
					height: '25vh',
					gap: 13,
					padding: '3.5%'
				}}
			>
			<Box
				alignItems='center'
				justifyContent='center'
				display='flex'
				sx={{
					height: '100%',
				}}
			>
    	  		<Avatar 
				alt='Asuka Langley Soryu'
				src={`${env.DOMAIN}/static/img/asuka-profile.jpg`}
				sx={{ 
					height: '20vh',
					width: '20vh',
				}}

				/>
			</Box>
			<Box
				alignItems='center'
				justifyContent='center'
				display='flex'
				sx={{
					height: '100%',
				}}
			>
				<div
					className='about-content'
					dangerouslySetInnerHTML={{ __html: aboutHtml }}
				/>
			</Box>
			</Box>

		</Box>

		</Container>
		<Footer />
		</AppTheme>
		</>
	);
}
